import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { z } from "zod"

import { removeUndefined } from "@tfg/types/schemas/utils"

export const useSearchParamsFilters = (schema: z.ZodType) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [filters, setFilters] = useState<z.infer<typeof schema>>(
    schema.parse(Object.fromEntries(searchParams.entries()))
  )

  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      ...removeUndefined(filters),
    }))
  }, [filters, setSearchParams])

  return [filters, setFilters]
}
